import React, { Component } from 'react'
import { connect } from 'react-redux'

class EditMode extends Component {
  render() {
    return (
      <p className='mode'>
        <span>MODE</span>:&nbsp;
        <span className={this.props.narrative.user_can_save ? 'mode mode--success' : 'mode mode--error'}>
          {!this.props.narrative || this.props.narrativeLoading || !this.props.userRole
            ? 'LOADING'
            : !this.props.narrative.user_can_save
            ? 'READ ONLY'
            : ['co_draft', 'co_review', 'rb_review'].includes(this.props.narrative.state_name) &&
              this.props.userRole === 'HQ'
            ? 'HQ OVERRIDE'
            : 'EDIT MODE'}
        </span>
      </p>
    )
  }
}

const mapStateToProps = state => ({
  narrative: state.narrative.narrative,
  narrativeLoading: state.narrative.narrativeLoading,
  userRole: state.appSettings.userInfo ? state.appSettings.userInfo.role : null,
})

EditMode = connect(
  mapStateToProps,
  null
)(EditMode)

export default EditMode
